export const GET_COURSE = "GET_COURSE";